import React from 'react';
import { useIntl } from 'react-intl';
import CardItem from '@/components/cards/CardItem';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import urls, { codeUrl } from '@/constants/urls';
import { taskRequestAssignedToMe, taskRequestWarning } from '../state/state';
import TaskCardItemExtra from './TaskCardItemExtra';
import TaskToolsMenu from './TaskToolsMenu';
import Events from '../hooks/events';
import taskDescription from '../helper';

const TaskCardItem = ({
  allowDatasetLink,
  allowRequestLink,
  canEdit,
  category,
  email,
  task,
  upward,
}) => {
  const intl = useIntl();
  const show = Events.useShowRequestTask();
  const error = taskRequestWarning(task);

  return (
    <CardItem
      active={error ? undefined : taskRequestAssignedToMe(email, task)}
      className="aridhia-task-card-item"
      error={error}
    >
      <NameDescriptionCard
        description={taskDescription(task, intl, { allowRequestLink, allowDatasetLink })}
        entity="task"
        href={codeUrl(urls.TASKS, task.code)}
        icon={error ? 'ban' : undefined}
        linkTarget="_self"
        markdown
        meta={task.workflow.name}
        name={task.name}
        onClick={() => show({ task })}
        withDescriptionShowMore
      >
        <TaskToolsMenu category={category} task={task} listItem upward={upward} />
      </NameDescriptionCard>
      <TaskCardItemExtra canEdit={canEdit} category={category} task={task} />
    </CardItem>
  );
};

export default TaskCardItem;
